/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

import { addNewUser, editExistingUser } from '../state/users';
import { FormInputField, PasswordInputField } from '../components/form/FormInputField';
import { generateFormErrors } from '../utils/generateFormErrors';

const NewUserForm = styled(Form)`
  display: flex;
  flex-direction: column;
`;

function UserForm(props) {
  const {
    t, history, addNewUser, editExistingUser, user, bindSubmitForm,
  } = props;

  return (
    <Formik
      initialValues={{
        email: user.email || '',
        userName: user.userName || '',
        displayName: user.displayName || '',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        status: user.status || false,
      }}
      onSubmit={async (values, { resetForm, setErrors }) => {
        try {
          if (isEmpty(user)) {
            await addNewUser(values);
          } else {
            await editExistingUser(user.id, values);
          }
          resetForm();
          history.push('/users');
        } catch (error) {
          const errorFields = generateFormErrors(error);
          setErrors(errorFields);
        }
      }}
      render={(props) => {
        bindSubmitForm(props.submitForm);

        return (
          <NewUserForm>
            <FormInputField
              inputId="UserForm.Input.Email"
              label={t('Shared.FormFields.Email')}
              labelId="UserForm.Label.Email"
              name="email"
              placeholder={t('Shared.Placeholders.Email')}
              type="email"
              error={props.errors.email}
              isRequired
              isReadOnly={!isEmpty(user)}
            />

            <PasswordInputField
              inputId="UserForm.Input.Password"
              label={t('Shared.FormFields.Password')}
              labelId="UserForm.Label.Password"
              name="password"
              placeholder={t('Shared.Placeholders.Password')}
              error={props.errors.password}
              isRequired={isEmpty(user)}
            />

            <FormInputField
              inputId="UserForm.Input.DisplayName"
              label={t('Shared.FormFields.DisplayName')}
              labelId="UserForm.Label.DisplayName"
              name="displayName"
              placeholder={t('Shared.Placeholders.DisplayName')}
              error={props.errors.displayName}
              isRequired
            />

            <FormInputField
              inputId="UserForm.Input.FirstName"
              label={t('Shared.FormFields.FirstName')}
              labelId="UserForm.Label.FirstName"
              name="firstName"
              placeholder={t('Shared.Placeholders.FirstName')}
              error={props.errors.firstName}
              isRequired
            />

            <FormInputField
              inputId="UserForm.Input.LastName"
              label={t('Shared.FormFields.LastName')}
              labelId="UserForm.Label.LastName"
              name="lastName"
              placeholder={t('Shared.Placeholders.LastName')}
              error={props.errors.lastName}
              isRequired
            />

            <FormInputField
              inputId="UserForm.Input.Status"
              label={t('Shared.FormFields.Status')}
              labelId="UserForm.Label.Status"
              name="status"
              placeholder={t('Shared.Placeholders.Status')}
              type="checkbox"
              checked={props.values.status}
              error={props.errors.status}
              isRequired
            />
          </NewUserForm>
        );
      }}
    />
  );
}

UserForm.propTypes = {
  t: PropTypes.func.isRequired, // supplied from withTranslation
  addNewUser: PropTypes.func.isRequired, // supplied from Redux
  bindSubmitForm: PropTypes.func.isRequired,
  editExistingUser: PropTypes.func.isRequired, // supplied from Redux
  history: PropTypes.object.isRequired, // supplied from React Router
  user: PropTypes.object,
};

UserForm.defaultProps = {
  user: {},
};

const mapDispatchToProps = {
  addNewUser,
  editExistingUser,
};

const TranslatedComponent = withTranslation()(UserForm);
const RouterComponent = withRouter(TranslatedComponent);
export default connect(
  null,
  mapDispatchToProps,
)(RouterComponent);
